var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../../../themes/styled";
import { ifProp } from "styled-tools";
import Grid from "./Grid";
var Two = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    grid-column: 1 / -1;\n    @media (min-width: ", ") {\n        grid-column-start: ", ";\n        grid-column-end: span 2;\n    }\n"], ["\n    grid-column: 1 / -1;\n    @media (min-width: ", ") {\n        grid-column-start: ", ";\n        grid-column-end: span 2;\n    }\n"])), function (p) { return p.theme.breakpoints[2]; }, ifProp("reverse", 10, 2));
var Eight = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    grid-column: 1 / -1;\n    @media (min-width: ", ") {\n        grid-column-start: ", ";\n        grid-column-end: span 8;\n    }\n"], ["\n    grid-column: 1 / -1;\n    @media (min-width: ", ") {\n        grid-column-start: ", ";\n        grid-column-end: span 8;\n    }\n"])), function (p) { return p.theme.breakpoints[2]; }, ifProp("reverse", 2, 4));
function TwoEight(_a) {
    var two = _a.two, eight = _a.eight, _b = _a.reverse, reverse = _b === void 0 ? false : _b, children = _a.children, rest = __rest(_a, ["two", "eight", "reverse", "children"]);
    return (React.createElement(Grid, __assign({}, rest),
        two && React.createElement(Two, { reverse: reverse }, two),
        eight && React.createElement(Eight, { reverse: reverse }, eight),
        children));
}
export default TwoEight;
var templateObject_1, templateObject_2;
//# sourceMappingURL=TwoEight.js.map